// UserHelpers.ts - Helpers para manejar datos del usuario
import {UserModel, ReporteModel} from './_models'

const USER_LOCAL_STORAGE_KEY = 'kt-user-data'

// Guardar usuario completo en localStorage
export const setUserInStorage = (user: UserModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(user)
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('USER LOCAL STORAGE SAVE ERROR', error)
  }
}

// Obtener usuario desde localStorage
export const getUserFromStorage = (): UserModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(USER_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const parsedData = JSON.parse(lsValue)
    // Verificar si los datos están anidados en una propiedad 'user' (estructura antigua o incorrecta)
    if (parsedData && parsedData.user && typeof parsedData.user === 'object') {
      return parsedData.user as UserModel
    }
    return parsedData as UserModel
  } catch (error) {
    console.error('USER LOCAL STORAGE PARSE ERROR', error)
  }
}

// Remover usuario de localStorage
export const removeUserFromStorage = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(USER_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('USER LOCAL STORAGE REMOVE ERROR', error)
  }
}

// Guardar solo reportes
export const setReportesInStorage = (reportes: ReporteModel[]) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(reportes)
    localStorage.setItem('kt-user-reportes', lsValue)
  } catch (error) {
    console.error('REPORTES LOCAL STORAGE SAVE ERROR', error)
  }
}

// Obtener reportes desde localStorage
export const getReportesFromStorage = (): ReporteModel[] | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem('kt-user-reportes')
  if (!lsValue) {
    return
  }

  try {
    const reportes: ReporteModel[] = JSON.parse(lsValue) as ReporteModel[]
    return reportes
  } catch (error) {
    console.error('REPORTES LOCAL STORAGE PARSE ERROR', error)
  }
}

// Actualizar reportes en el usuario existente
export const updateUserReportes = (user: UserModel, reportes: ReporteModel[]): UserModel => {
  return {
    ...user,
    reportes,
  }
}

